// image-modal.js
import { trapFocus, releaseFocus } from '../utils/focusManager.js';
import { stateManager } from '../utils/stateManager.js';

export class ImageModal {
  constructor(baseQueryEl = document) {
    this.baseQueryEl = baseQueryEl;
    this.modal = null;
    this.modalImg = null;
    this.closeBtn = null;
    this.nextBtn = null;
    this.prevBtn = null;
    this.images = [];
    this.currentIndex = 0;
  }

  init() {
    this.modal = this.baseQueryEl.getElementById('ImageModal');
    this.closeBtn = this.baseQueryEl.getElementById('ImageModalClose');
    this.nextBtn = this.baseQueryEl.getElementById('ImageModalNext');
    this.prevBtn = this.baseQueryEl.getElementById('ImageModalPrev');
    this.images = Array.from(this.baseQueryEl.querySelectorAll('.product__media img'));

    if (!this.modal || !this.images.length) return;

    if (this.images.length <= 1) {
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      if (this.prevBtn) this.prevBtn.style.display = 'none';
    }

    // console.log(this.images);
    this.images.forEach((img, index) => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => this.openModal(index));
    });

    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeModal());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.showNext());
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.showPrev());

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('open')) {
        this.closeModal();
      }
    });
  }

  openModal(index) {
	this.currentIndex = index;
  const src = this.images[this.currentIndex].getAttribute('data-full-src') || this.images[this.currentIndex].src;

  let currentActiveImg = this.modal.querySelector('.image-modal__img.active');
  let existingImg = Array.from(this.modal.querySelectorAll('.image-modal__img')).find((img) => img.src === src);

  if (existingImg) {
    if (currentActiveImg) currentActiveImg.classList.remove('active');
    existingImg.classList.add('active');
  } else {
    const img = document.createElement('img');
    img.classList.add('image-modal__img', 'active');
    img.src = src;

    img.alt = ''; // You can customize this
    this.modal.querySelector('.image-modal__content').appendChild(img);

    if (currentActiveImg) currentActiveImg.classList.remove('active');
  }

  this.modal.classList.add('open');
  trapFocus(this.modal);
  stateManager.setState({ imageModalOpen: true, currentIndex: this.currentIndex });
  }

  closeModal() {
    this.modal.classList.remove('open');
    releaseFocus();
    stateManager.setState(null);
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.openModal(this.currentIndex);
  }

  showPrev() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.openModal(this.currentIndex);
  }
}